var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.583 2.014A24.771 24.771 0 0025.29 0c5.057 6.678-.55 16.692-9.78 18.286C19.586 6.506 10.036 9.814 13.22.13c-2.467.766-4.747 2.039-6.65 3.883-6.189 6-10.227 15.907-1.702 27.144.374-4.358 1.076-6.49 4.35-8.01-.42 10.56 5.48 19.198 11.905 20.978-.428-11.779 3.664-10.258 6.802-21.378 2.466 1.612 2.613 5.508 2.406 6.448 11.805-11.654 7.885-23.211.252-27.181z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.5e16d7aaa00245b6ab73deadddb61234.svg";
export { ForwardRef as ReactComponent };